import { forwardRef } from "react";

interface CloseProps {
  close: () => void;
}

const withClose = <P extends object>(Component: React.ComponentType<P>) => {
  return forwardRef<any, React.PropsWithChildren<P & CloseProps>>(
    ({ children, close, ...props }, ref) => {
      return (
        <Component onClick={close} ref={ref} {...(props as P)}>
          {children}
        </Component>
      );
    },
  );
};

export { withClose };
